import { get } from 'lodash-es'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

// import { getLinkUrlOfType, getLinkAllowedOfType } from '@/js/helper/links-helper.js'

// import API_CONSTANTS from '@/js/helper/api-constants.js'
import GETTER_TYPES from '../getter-types'

export const getProductsGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.PRODUCTS_PROMISE]: state => get(state, MUTATION_TYPES.PRODUCTS.promiseKey),
  [GETTER_TYPES.PRODUCTS_DATA]: state => get(state, MUTATION_TYPES.PRODUCTS.dataKey),
  [GETTER_TYPES.PRODUCT_PROMISE]: state => get(state, MUTATION_TYPES.PRODUCT.promiseKey),
  [GETTER_TYPES.PRODUCT_DATA]: state => get(state, MUTATION_TYPES.PRODUCT.dataKey),
  [GETTER_TYPES.PRODUCT_MESSAGE]: state => get(state, MUTATION_TYPES.PRODUCT.errorMessageKey),
  [GETTER_TYPES.PRODUCTATTRIBUTES_DATA]: state =>
    get(state, MUTATION_TYPES.PRODUCTATTRIBUTES.dataKey, {}),
  [GETTER_TYPES.PRODUCTATTRIBUTES_PENDING]: state =>
    get(state, MUTATION_TYPES.PRODUCTATTRIBUTES.stateKey, REQUEST_STATE.STATE_FAILURE) ===
    REQUEST_STATE.STATE_PENDING,
  [GETTER_TYPES.PRODUCTATTRIBUTES_FAILED]: state =>
    get(state, MUTATION_TYPES.PRODUCTATTRIBUTES.stateKey, REQUEST_STATE.STATE_FAILURE) ===
    REQUEST_STATE.STATE_FAILURE,
})
